import "core-js/modules/es.object.assign.js";
import _isNil from "lodash/isNil";
import _get from "lodash/get";
import _startCase from "lodash/startCase";
import _isString from "lodash/isString";
import _isPlainObject from "lodash/isPlainObject";
import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { CheckButton } from '../Button';
import { Row, Col } from '../Grid';
import { tableRow, tableCell, tableCellEmpty, tableBodyWrap, moreWrap, moreItem } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var NullItem = function NullItem() {
  return ___EmotionJSX("div", {
    css: tableCellEmpty
  });
};

export var displayValue = function displayValue(column, row) {
  var value = _get(row, column.value.split('.'));

  switch (true) {
    case _isPlainObject(column.mapValue):
      return column.mapValue[value.toLowerCase()];

    case _isString(column.dateTimeFormat):
      return moment(value).isValid() ? moment(value).format(column.dateTimeFormat) : ___EmotionJSX(NullItem, null);

    case column.startCase:
      return _startCase(value);

    default:
      return !_isNil(value) && String(value).length ? String(value) : ___EmotionJSX(NullItem, null);
  }
};
export var isEmptyValue = function isEmptyValue(column, row) {
  var _column$value;

  var value = _get(row, (_column$value = column.value) === null || _column$value === void 0 ? void 0 : _column$value.split('.'));

  if (value) return false;
  return !(_isFunction(column.render) && column.render(row, NullItem) === '');
};

var TableBody = function TableBody(props) {
  var data = props.data,
      columns = props.columns,
      columnsMore = props.columnsMore,
      selectRow = props.selectRow,
      hasSelection = props.hasSelection,
      renderRow = props.renderRow,
      onRowClick = props.onRowClick,
      rowLink = props.rowLink;
  var hasMore = (columnsMore === null || columnsMore === void 0 ? void 0 : columnsMore.length) > 0;
  var RowComp = _isFunction(rowLink) ? Link : 'div';
  return data.map(function (row, i) {
    var _row$render, _row$_table;

    return _isFunction(row.render) || _isFunction(renderRow) ? ((_row$render = row.render) !== null && _row$render !== void 0 ? _row$render : renderRow)({
      row: row,
      NullItem: NullItem,
      columns: columns,
      rowClassName: tableRow,
      columnClassName: tableCell,
      displayValue: displayValue
    }) : ___EmotionJSX("div", {
      css: tableBodyWrap,
      key: "table-row-".concat(i)
    }, ___EmotionJSX(RowComp, _extends({
      css: tableRow(_isFunction(rowLink) || _isFunction(onRowClick))
    }, _isFunction(rowLink) && rowLink(row), _isFunction(onRowClick) && {
      onClick: function onClick() {
        return onRowClick(row);
      }
    }), hasSelection && ___EmotionJSX("div", {
      role: "presentation",
      css: tableCell({
        width: 40,
        render: true
      }),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, ___EmotionJSX(CheckButton, {
      onChange: function onChange(val) {
        return selectRow(val, row);
      },
      value: row === null || row === void 0 ? void 0 : (_row$_table = row._table) === null || _row$_table === void 0 ? void 0 : _row$_table.isSelected
    })), columns.map(function (column, j) {
      return ___EmotionJSX("div", {
        key: "table-column".concat(i, "-").concat(j),
        css: tableCell(column)
      }, _isFunction(column.render) ? column === null || column === void 0 ? void 0 : column.render(row, NullItem) : displayValue(column, row));
    })), hasMore && ___EmotionJSX("div", {
      css: moreWrap
    }, ___EmotionJSX(Row, {
      horizontalGap: 16
    }, columnsMore === null || columnsMore === void 0 ? void 0 : columnsMore.map(function (columnMore, j) {
      return (!columnMore.hideIfEmpty || isEmptyValue(columnMore, row)) && ___EmotionJSX(Col, {
        sm: "auto",
        md: "auto",
        key: "table-column-more".concat(i, "-").concat(j)
      }, ___EmotionJSX("div", {
        css: moreItem
      }, ___EmotionJSX("strong", null, columnMore === null || columnMore === void 0 ? void 0 : columnMore.name, ": "), _isFunction(columnMore.render) ? columnMore === null || columnMore === void 0 ? void 0 : columnMore.render(row, NullItem) : displayValue(columnMore, row)));
    }))));
  });
};

TableBody.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  columnsMore: PropTypes.array,
  selectRow: PropTypes.func,
  hasSelection: PropTypes.bool,
  renderRow: PropTypes.func
};
export default TableBody;